import { render } from "./DialogSuccess.vue?vue&type=template&id=6bf01c0a&scoped=true"
import script from "./DialogSuccess.vue?vue&type=script&lang=js"
export * from "./DialogSuccess.vue?vue&type=script&lang=js"

import "./DialogSuccess.vue?vue&type=style&index=0&id=6bf01c0a&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bf01c0a"]])

export default __exports__